import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { describe } from 'react-desc';
import DSDropdownMenu from '@elliemae/ds-dropdownmenu';
import DSInputMask from '@elliemae/ds-form/InputMask';
import { InputSearchWrapper } from './components/blocks.js';
import { createDisabledOption, noAddonOptions } from './components/helper.js';
import { zipcodeSearchProps, defaultProps } from './props.js';
import '@elliemae/ds-classnames';
import '@babel/runtime/helpers/esm/defineProperty';

var DSZipCodeSearch = function DSZipCodeSearch(_ref) {
  var disabled = _ref.disabled,
      value = _ref.value,
      placeholder = _ref.placeholder,
      mask = _ref.mask,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      containerProps = _ref.containerProps,
      selectRightOptions = _ref.selectRightOptions,
      activeCount = _ref.activeCount,
      options = _ref.options,
      tabIndex = _ref.tabIndex;
  var ref = useRef(null);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isActive = _useState6[0],
      setIsActive = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isInputFocus = _useState8[0],
      setIsInputFocus = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isSelected = _useState10[0],
      setIsSelected = _useState10[1];

  useEffect(function () {
    if (isInputFocus && activeCount <= searchValue.length && !isSelected) {
      setIsOpen(true);
      setIsActive(true);
    } else if (!isActive || activeCount > searchValue.length) {
      setIsOpen(false);
    }
  }, [isInputFocus, isActive, activeCount, searchValue]);
  useEffect(function () {
    setSearchValue(value || '');
  }, [value]);
  var onTypeInInput = useCallback(function (e) {
    var finalVal = e.target.value;
    onSearch(finalVal);
    setSearchValue(finalVal);
    setIsSelected(false);
  }, [onSearch]);
  var onFocusInput = useCallback(function () {
    setIsInputFocus(true);
  }, []);
  var onInnerBlur = useCallback(function (e) {
    setIsInputFocus(false);
    onBlur(e);
  }, [onBlur]);
  var onClose = useCallback(function () {
    setIsActive(false);
  }, []);
  var onSelectItem = useCallback(function (item) {
    setSearchValue(item.value);
    onChange(item);
    setIsSelected(true);
    ref.current.focus();
    setIsOpen(false);
    onClose();
  }, []);
  return /*#__PURE__*/React.createElement(InputSearchWrapper, containerProps, /*#__PURE__*/React.createElement(DSDropdownMenu, {
    isOpen: isOpen && options.length > 0,
    menuProps: {
      className: 'input-search-menu'
    } // onBlur={() => console.log('inblur;')}
    ,
    onClose: onClose,
    onSelectMenuItem: onSelectItem,
    options: options.length > 0 ? [createDisabledOption(selectRightOptions)].concat(_toConsumableArray(noAddonOptions(options))) : [],
    triggerComponent: /*#__PURE__*/React.createElement(DSInputMask, {
      disabled: disabled,
      innerRef: ref,
      mask: mask,
      onBlur: onInnerBlur,
      onChange: onTypeInInput,
      onFocus: onFocusInput,
      placeholder: placeholder,
      value: searchValue,
      tabIndex: tabIndex
    })
  }));
};

DSZipCodeSearch.propTypes = zipcodeSearchProps;
DSZipCodeSearch.defaultProps = defaultProps;
var ZipCodeSearchWithSchema = describe(DSZipCodeSearch);
ZipCodeSearchWithSchema.propTypes = zipcodeSearchProps;

export default DSZipCodeSearch;
export { DSZipCodeSearch, ZipCodeSearchWithSchema };
//# sourceMappingURL=DSZipCodeSearch.js.map
